import { render, staticRenderFns } from "./collect_paper.vue?vue&type=template&id=12cd3b66&scoped=true&"
import script from "./collect_paper.vue?vue&type=script&lang=js&"
export * from "./collect_paper.vue?vue&type=script&lang=js&"
import style0 from "./collect_paper.vue?vue&type=style&index=0&id=12cd3b66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cd3b66",
  null
  
)

export default component.exports